import { SvgIcon, SvgIconProps } from "@material-ui/core";
import classNames from "classnames";
import React, { MouseEventHandler, ReactNode } from "react";

interface CardProps {
  className?: string;
  onClick?: MouseEventHandler;
  children?: ReactNode;
  emphasis?: boolean;
}

interface CardIconProps extends Omit<CardProps, "leftContent"> {
  Icon: typeof SvgIcon;
  badged?: boolean;
  iconProps?: SvgIconProps;
}

export const Card = ({ onClick, className, children, emphasis = false }: CardProps) => {
  let borderClasses: string;
  let bgClasses: string;
  if (emphasis) {
    bgClasses = onClick
      ? "cw-bg-brand-emphasis hover:cw-bg-brand-emphasis-hover active:cw-bg-brand-emphasis-pressed"
      : "cw-bg-brand-emphasis";
    borderClasses = onClick
      ? "cw-border-brand-emphasis hover:cw-border-brand-emphasis-hover active:cw-border-brand-emphasis-pressed"
      : "cw-border-brand-emphasis";
  } else {
    bgClasses = onClick
      ? "cw-bg-default hover:cw-bg-default-hover active:cw-bg-default-pressed"
      : "cw-bg-default";
    borderClasses = onClick
      ? "cw-border-default hover:cw-border-default-hover active:cw-border-default-pressed"
      : "cw-border-default";
  }

  return (
    <div
      cw-id="card"
      onClick={onClick}
      className={classNames(
        "cw-relative cw-overflow-hidden cw-select-none",
        "cw-border cw-border-solid cw-rounded-lg",
        bgClasses,
        borderClasses,
        { "cw-cursor-pointer": onClick },
        className,
      )}
    >
      {children}
    </div>
  );
};

export const CardIcon = ({
  Icon,
  badged = false,
  iconProps,
  children,
  className,
  ...cardProps
}: CardIconProps) => (
  <Card
    {...cardProps}
    className={classNames(className, "cw-flex cw-items-center cw-mt-4 cw-px-4 cw-py-3")}
  >
    <div className="cw-pr-[14px] cw-mb-[-3px]">
      <div className="cw-relative">
        <Icon {...iconProps} className={classNames("cw-text-20", iconProps?.className)} />
        {badged && (
          <div className="cw-w-2 cw-h-2 cw-rounded-full cw-bg-destructive-emphasis cw-absolute cw-top-[-1px] cw-right-[-1px]" />
        )}
      </div>
    </div>
    <div className="cw-flex-1 cw-max-w-full">{children}</div>
  </Card>
);
